import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import api from "lib/api";
import { useHistory } from "react-router-dom";
import { FormJSON } from "exportForm/exportForm";
import axios from "axios";
import UploadDialog from "components/UploadDialog";

export default () => {
	const { t } = useTranslation();
	const history = useHistory();

	const [error, setError] = useState<string | null>(null);
	const [isUploaded, setIsUploaded] = useState<boolean>(false);

	const [formId, setFormId] = useState<string | null>(null);
	const [formEntity, setFormEntity] = useState<string | null>(null);
	const [formDefinition, setFormDefinition] = useState<FormJSON | null>(null);

	/**
	 * Validate the form then upload to form designer
	 *
	 * @param file uploaded
	 */
	const handleValidation = useCallback(async file => {
		try {
			// Parse the file so that it is in JSON
			const json = JSON.parse(file);

			// Check if the form is valid
			if (await api.definitions.runFormValidation(json)) {
				// Get the ID and entity of the form and then store it later
				const id = json.view?.id;
				const entity = json.view?.resource;
				setFormDefinition(json);
				setFormId(id?.substring(id?.lastIndexOf("/") + 1));
				entity === null
					? setFormEntity("NoEntity")
					: setFormEntity(
							entity?.substring(entity?.lastIndexOf("/") + 1)
					  );
				// Set isUploaded as true so that the UploadDialog knows that
				// the upload has been successful
				setIsUploaded(true);
			}
		} catch (error) {
			if (error && axios.isAxiosError(error)) {
				// If the error is a 504 then it means that the form has failed validation
				error.response?.status === 504
					? setError("errorValidatingFormUpload")
					: setError("failValidatingFormUpload");
				console.error(`Error: ${error.message}`);
			} else {
				setError("failValidatingFormUpload");
				console.error(`Error: ${error}`);
			}
		}
	}, []);

	const handleUploaded = useCallback(() => {
		// When the form is uploaded we need to go to the form designer page
		if (formDefinition && formId && formEntity)
			history.push({
				pathname: "/formdesigner/create",
				search: `?formId=${formId}&formEntity=${formEntity}`,
				state: formDefinition,
			});
	}, [formDefinition, formEntity, formId, history]);

	return (
		<UploadDialog
			btnLabel={t("formDesigner.labels.uploadForm")}
			title={t("formDesigner.labels.uploadFormDefinition")}
			acceptJson
			onUploaded={handleUploaded}
			onValidation={handleValidation}
			file="form"
			btnClass="btn-outline-primary"
			error={error}
			isUploaded={isUploaded}
			clearError={() => setError(null)}
		/>
	);
};
